import type { GamesByClubs, HomeGamesError, PageData } from '@swf/core/types/Poker';
import { ClubPlayerRole, UserClubRole } from '@swf/core/types/Poker';

import {
  TXTCLI_Admin,
  TXTCLI_Guest,
  TXTCLI_Manager,
  TXTCLI_Member,
  TXTCLI_Observer,
  TXTCLI_Suspended,
  TXTWCL_Waiting_for_Confirmation
} from './constants.messages.json';

export const PKR_INITIAL_GAMES_DATA: GamesByClubs = {};
export const PKR_INITIAL_TOURNAMENT_DATA: GamesByClubs = {};
export const PKR_LOADERS = {
  userClubs: 'userClubs',
  clubInfo: 'clubInfo',
  clubOptionsById: (clubId: string | number) => `clubOptionsById-${clubId}`,
  userClubsAndGames: 'userClubsAndGames',
  registeredTournaments: 'registeredTournaments',
  playersByClubId: (clubId: string | number) => `playersByClubId-${clubId}`,
  playerTournamentResults: 'playerTournamentResults',
  clubMembers: 'clubMembers',
  clubSeasons: 'clubSeasons',
  clubSeasonStats: 'clubSeasonStats',
  clubSeasonSummaries: 'clubSeasonSummaries',
  initial: 'initial'
};
export const PKR_INITIAL_ERROR: HomeGamesError = {
  critical: false,
  info: false,
  major: false,
  minor: false
};

export const PKR_INITIAL_STATE: PageData = {
  clubs: [],
  games: {
    tables: [],
    tourns: [],
    recentTourns: [],
    registeredTourns: [],
    selectedGameIds: []
  },
  clubOptionsById: {},
  playersByClubId: {},
  playerTournamentResults: [],
  clubMembers: [],
  clubSeasonsById: {},
  clubSeasonStatsById: {},
  clubRecentTournamentSummary: [],
  error: PKR_INITIAL_ERROR,
  loading: {
    [PKR_LOADERS.initial]: true,
    [PKR_LOADERS.clubInfo]: true,
    [PKR_LOADERS.clubSeasonSummaries]: true
  },
  uiLayout: {
    clubNavHidden: false,
    standingsPlayMoneyFlag: false
  }
};

export const PKR_ROLE_TRANSLATIONS = {
  [UserClubRole.Manager]: TXTCLI_Manager,
  [UserClubRole.Admin]: TXTCLI_Admin,
  [UserClubRole.Member]: TXTCLI_Member,
  [UserClubRole.Observer]: TXTCLI_Observer,
  [UserClubRole.Guest]: TXTCLI_Guest,
  [UserClubRole.Confirmation]: TXTWCL_Waiting_for_Confirmation,
  [UserClubRole.Suspended]: TXTCLI_Suspended
};

export const PKR_USER_ROLE_TRANSLATIONS = {
  [ClubPlayerRole.FOUNDER]: TXTCLI_Manager,
  [ClubPlayerRole.ADMIN]: TXTCLI_Admin,
  [ClubPlayerRole.MEMBER]: TXTCLI_Member,
  [ClubPlayerRole.OBSERVER]: TXTCLI_Observer,
  [ClubPlayerRole.GUEST]: TXTCLI_Guest,
  [ClubPlayerRole.APPLIED]: TXTWCL_Waiting_for_Confirmation,
  [ClubPlayerRole.SUSPENDED]: TXTCLI_Suspended
};

export const PKR_AVATAR_COUNT = 4;

export const PKR_CLUB_NAV_ID = 'homegames-club-nav';

export const PKR_RESTRICTED_SYMBOLS = /<|>|\{|\}|\(|\)|\[|\]/;
export const PKR_RESTRICTED_SYMBOLS_STRING = PKR_RESTRICTED_SYMBOLS.source.replace(/[|\\]/g, ' ');
export const PKR_RETRY_INTERVALS = [1000, 3000, 6000];
